import { Notification } from "../../../entities/notification";
import NotificationRepository from "../../ports/notificationRepository";

export type updateNotificationUseCase = (
  id: string,
  data: Partial<Notification>
) => Promise<void>;

export const buildUpdateNotification = (dependencies: {
  notificationRepo: NotificationRepository;
}): updateNotificationUseCase => {
  const { notificationRepo } = dependencies;

  const updateNotification = async (id: string, data: Partial<Notification>) => 
    notificationRepo.updateNotification(id, data);

    return updateNotification;
}